import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
} from '@angular/core';

export type TrInfoTooltipPlacement =
    | 'bottom-start'
    | 'bottom'
    | 'bottom-end'
    | 'right'
    | 'left';

@Component({
    selector: 'tr-info-tooltip',
    templateUrl: './tr-info-tooltip.component.html',
    styleUrls: ['./tr-info-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrInfoTooltipComponent {
    @Input() public triggerText: string = '';
    @Input() public title: string = '';
    @Input() public description: string = '';
    @Input() public placement: TrInfoTooltipPlacement = 'bottom-start';
    @Input() public openOnHover: boolean = false;

    /** Texto do botão de confirmação exibido no modo mobile. */
    @Input() public confirmText: string = 'Entendi';

    /** Título alternativo para o modo mobile. Se vazio, usa `triggerText` ou `title`. */
    @Input() public mobileTitle: string = '';

    @Output() public opened: EventEmitter<void> = new EventEmitter<void>();
    @Output() public closed: EventEmitter<void> = new EventEmitter<void>();

    public isOpen: boolean = false;

    constructor(
        private elementRef: ElementRef<HTMLElement>,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    public onMouseEnter(): void {
        if (this.openOnHover) this.open();
    }

    public toggle(event: Event): void {
        event.stopPropagation();

        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    public open(): void {
        if (this.isOpen) return;
        this.isOpen = true;
        this.opened.emit();
        this.changeDetectorRef.markForCheck();
    }

    public close(): void {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.closed.emit();
        this.changeDetectorRef.markForCheck();
    }

    /** Fecha o tooltip quando o usuário pressiona ESC. */
    @HostListener('document:keydown.escape')
    public onEscape(): void {
        this.close();
    }

    /** Fecha o tooltip ao clicar fora do componente. */
    @HostListener('document:click', ['$event'])
    public onDocumentClick(event: MouseEvent): void {
        if (
            this.isOpen &&
            !this.elementRef.nativeElement.contains(event.target as Node)
        ) {
            this.close();
        }
    }
}
